import styled from "styled-components";

export default styled.div`
  cursor: pointer;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 10px;

  width: 328px;
  height: 60px;


  background: #FFFFFF;

  border: 1px solid #e8344e;
  border-radius: 8px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  display: flex;
  align-items: center;
  text-align: center;


  color: #e8344e;
`
